import React from 'react';
import { useTranslation } from 'react-i18next';

export default function KPICards({
    totalUser = 0,
    totalMax = 0,
    percentage = 0,
    formattedTime = '00:00',
    avgTimePerQuestion = '00:00',
    solvedCount = 0,
    totalQuestions = 0
}) {
    const { t } = useTranslation('common');

    const getColorForPct = (p) => {
        if (p >= 90) return '#16a34a'; // green-600
        if (p >= 80) return '#22c55e'; // green-500
        if (p >= 70) return '#65a30d'; // lime-600
        if (p >= 60) return '#eab308'; // yellow-500
        if (p >= 50) return '#f59e0b'; // amber-500
        return '#ef4444';             // red-500
    };

    const completionRate = totalQuestions > 0 ? Math.round((solvedCount / totalQuestions) * 100) : 0;
    const scoreRate = totalMax > 0 ? Math.round((totalUser / totalMax) * 100) : 0;

    return (
        <div className="lr-kpi-grid lr-anim-fade-up">
            {/* 1. Total Marks */}
            <div className="lr-kpi-card kpi-card--marks">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--indigo">
                            <i className="fas fa-calculator"></i>
                        </span>
                        <span>{t('Pages.Lessons.Summary.totalMarks') || t('Pages.Exams.Marks') || 'مجموع العلامات'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: getColorForPct(scoreRate) }}>
                        {Number(totalUser).toFixed(1)} / {totalMax}
                    </span>
                </div>
                <div className="lr-kpi-bar">
                    <div
                        className="lr-kpi-bar-fill"
                        style={{
                            width: `${Math.min(100, Math.max(0, scoreRate))}%`,
                            background: getColorForPct(scoreRate)
                        }}
                    />
                </div>
                <div className="lr-kpi-sub">
                    <span>{t('Pages.Lessons.Summary.masteryRate') || 'مستوى الإنجاز'}</span>
                    <span className="font-bold">{scoreRate}%</span>
                </div>
            </div>

            {/* 2. Percentage */}
            <div className="lr-kpi-card kpi-card--pct">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--emerald">
                            <i className="fas fa-chart-pie"></i>
                        </span>
                        <span>{t('Pages.Lessons.Summary.percentage') || t('Pages.Exams.MarkRate') || 'النسبة المئوية'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: getColorForPct(percentage) }}>
                        {percentage}%
                    </span>
                </div>
                <div className="lr-kpi-bar">
                    <div
                        className="lr-kpi-bar-fill"
                        style={{
                            width: `${Math.min(100, Math.max(0, percentage))}%`,
                            background: getColorForPct(percentage)
                        }}
                    />
                </div>
                <div className="lr-kpi-sub">
                    <span>{percentage >= 50 ? (t('Pages.Lessons.Summary.excellent') || 'ناجح') : (t('Pages.Lessons.Summary.failed') || 'بحاجة لتحسين')}</span>
                    <span className="font-bold">{percentage >= 85 ? '🌟' : percentage >= 50 ? '👍' : '🎯'}</span>
                </div>
            </div>

            {/* 3. Time Elapsed */}
            <div className="lr-kpi-card kpi-card--time">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--amber">
                            <i className="fas fa-clock"></i>
                        </span>
                        <span>{t('Pages.Lessons.Summary.timeTaken') || t('Pages.Exams.yourTime') || 'الوقت المستغرق'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: '#d97706' }}>
                        {formattedTime}
                    </span>
                </div>
                <div className="lr-kpi-bar">
                    <div
                        className="lr-kpi-bar-fill"
                        style={{
                            width: '100%',
                            background: '#f59e0b'
                        }}
                    />
                </div>
                <div className="lr-kpi-sub">
                    <span>{t('Pages.Lessons.Summary.avgPerQuestion') || 'معدل السؤال'}</span>
                    <span className="font-bold text-slate-700">{avgTimePerQuestion}</span>
                </div>
            </div>

            {/* 4. Answered Questions */}
            <div className="lr-kpi-card kpi-card--tasks">
                <div className="lr-kpi-header">
                    <span className="lr-kpi-title">
                        <span className="kpi-icon-wrap kpi-icon--sky">
                            <i className="fas fa-tasks"></i>
                        </span>
                        <span>{t('Pages.Lessons.Summary.answeredCount') || 'الأسئلة المجابة'}</span>
                    </span>
                    <span className="lr-kpi-value" style={{ color: '#0284c7' }}>
                        {solvedCount} / {totalQuestions}
                    </span>
                </div>
                <div className="lr-kpi-bar">
                    <div
                        className="lr-kpi-bar-fill"
                        style={{
                            width: `${Math.min(100, Math.max(0, completionRate))}%`,
                            background: '#0284c7'
                        }}
                    />
                </div>
                <div className="lr-kpi-sub">
                    <span>{t('Pages.Lessons.Summary.questionsCount') || 'نسبة الإجابة'}</span>
                    <span className="font-bold">{completionRate}%</span>
                </div>
            </div>
        </div>
    );
}
